import { PROCESSED_STATUS } from '../constants';

const getColorForStatus = actionStatus => {
  const {
    ACTIVE,
    ACTION_REQUIRED,
    PAPERWORK_RECEIVED,
    SUBMITTED_FOR_PROCESSING,
    COMPLETED,
    X1_ACTIVE_ITEMS,
    X2_ACTIVE_ITEMS,
    X3_ACTIVE_ITEMS,
    X4_ACTIVE_ITEMS,
    PAUSED,
  } = PROCESSED_STATUS;
  const blue = {
    medium: 'var(--cvna-color-blue-4)',
    dark: 'var(--cvna-color-blue-6)',
  };
  const gray = 'var(--cvna-color-grey-1)';
  const white = 'var(--cvna-color-white)';
  const red = 'var(--cvna-color-red-2)';
  const green = 'var(--cvna-color-green-2)';
  const yellow = 'var(--cvna-color-yellow-3)'
  
  switch (actionStatus) {
    case ACTION_REQUIRED:
      return {
        text: white,
        background: red
      };
    case PAPERWORK_RECEIVED:
    case SUBMITTED_FOR_PROCESSING:
      return {
        text: white,
        background: blue.medium
      };
    case ACTIVE:
    case COMPLETED:
    case X1_ACTIVE_ITEMS:
    case X2_ACTIVE_ITEMS:
    case X3_ACTIVE_ITEMS:
    case X4_ACTIVE_ITEMS:
      return {
        text: white,
        background: green
      };
    case PAUSED:
      return {
        text: white,
        background: yellow
      };
    default:
      return {
        text: blue.dark,
        background: gray
      };
  }
}

export default getColorForStatus;